import script from "./DirectMessageBubble.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectMessageBubble.vue?vue&type=script&setup=true&lang=js"

import "./DirectMessageBubble.vue?vue&type=style&index=0&id=58dca51e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58dca51e"]])

export default __exports__